// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__EZZf6","Name":"Table_Name__2HvJ5","Row":"Table_Row__3-EKi","Total":"Table_Total__2idM0","First":"Table_First__2az_G","Nothing":"Table_Nothing__2ma8z"};